import { render, staticRenderFns } from "./ProfileAchievement.vue?vue&type=template&id=5a55c76b&scoped=true&"
import script from "./ProfileAchievement.vue?vue&type=script&lang=js&"
export * from "./ProfileAchievement.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAchievement.vue?vue&type=style&index=0&id=5a55c76b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55c76b",
  null
  
)

export default component.exports